module.exports = __webpack_public_path__ + "img/defaultVoucherIco.41bc40f8.png";